/**
 * @generated SignedSource<<486b95b8c5a0fb279158cc3ecdf55acb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type signup_Query$variables = {};
export type signup_Query$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"signup_viewer">;
  } | null;
};
export type signup_Query = {
  variables: signup_Query$variables;
  response: signup_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "signup"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"signup\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "signup_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "signup_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "signup_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downForMaintenance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e898c3d66228eb4af811f19a168df016",
    "id": null,
    "metadata": {},
    "name": "signup_Query",
    "operationKind": "query",
    "text": "query signup_Query {\n  viewer {\n    component(name: \"signup\")\n    ...signup_viewer\n    id\n  }\n}\n\nfragment signup_viewer on Viewer {\n  actualPersonId\n  downForMaintenance\n}\n"
  }
};
})();

(node as any).hash = "3d7f885e1fc813b1b38c96353d514932";

export default node;
